import React from "react";
import { Typography, Link } from "@mui/material";
import Jira_Img from "../../../assets/baseVersion/Jira_Img.svg"

interface TicketLinkRendererProps {
  value: string;
  data: {
    ticket_url: string | null;
    issue_key: string;
  };
}

const TicketLinkRenderer: React.FC<TicketLinkRendererProps> = (props) => {
  // Construct Jira URL from issue key if ticket_url is null
  const getTicketUrl = () => {
    if (props.data.ticket_url) {
      return props.data.ticket_url;
    }
    // Construct URL based on issue key format (e.g., TTS-274)
    const [projectKey] = props.data.issue_key.split('-');
    return `https://eficensit.atlassian.net/browse/${props.data.issue_key}`;
  };

  const ticketUrl = getTicketUrl();

  return (
    <Link 
      href={ticketUrl} 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ 
        color: 'inherit', 
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {props.value}
      </Typography>
      {/* <svg 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginLeft: '4px' }}
      >
        <path 
          d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M15 3h6v6" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M10 14L21 3" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg> */}
      <img src={Jira_Img} alt="" style={{marginLeft:3}}/>
    </Link>
  );
};

export default TicketLinkRenderer; 